import {NG_VALUE_ACCESSOR, NgControl} from '@angular/forms';
import {Directive, forwardRef, Injector, Input} from "@angular/core";

@Directive({
    selector: '[disableControl]'

})
export class DisableControlDirective {
    ngControl: NgControl;
    @Input() set disableControl(condition: { mode: boolean; timeoutToEnable: number }) {
        const action = condition.mode ? 'disable' : 'enable';
        if (!this.ngControl){
            this.ngControl = this._injector.get(NgControl);
        }
        this.ngControl.control?.[action]();
        if (condition.timeoutToEnable > 0) {
            setTimeout(() => {
                this.ngControl.control?.['enable']();
            }, condition.timeoutToEnable);
        }
    }

    constructor(private _injector: Injector) {
    }

}
